import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { Singleton } from "../../../../../core/services/Singleton";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _PilaDataSheets, _SecuritySpreadSheetProcess } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { AdminProcess } from "../../../../erp/cellEditor/PaymentHeader/AdminProcess";
import { AccountantYear } from "../../../GestionTH/EmployeeContract/ProductionPlan/AccountantYear";
import { MonthEditorbyconst } from "../../../../RemoteAbstractAction/editors/MonthEditorbyconst";


interface Props {
    idSocialSecuritySpreadSheet: number;
}

export const PilaDataSheets = ({ idSocialSecuritySpreadSheet }: Props) => {

    const pila = useDataBean(_PilaDataSheets);
    const single = Singleton.getInstance();
    const [Year, setYear] = useState<any>(_single.getCurrenYear());
    const [Month, setMonth] = useState<any>(_single.getCurrentMonth());
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idSocialSecuritySpreadSheet])

    const getLista = () => {

        pila.instance.getPilaDataSheets(idSocialSecuritySpreadSheet).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        // template.setBean({
        //     IDSocialSecurityTemplate: idSocialSecurityTemplate
        // });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {


    }
    const editaItem = () => {



    }
    const setPilaDataApplied = () => {

        pila.instance.setPilaDataApplied(idSocialSecuritySpreadSheet, pila.bean.Filename, Year, Month).then(
            (resp) => {
                if (resp) {
                    setModal({ ...modal, "view": false });
                    toast.success('Período Definindo');
                }


            }
        ).catch(
            err => { toast.error(err) }
        )
    }
    const head = [
        { title: 'Archivo', property: 'Filename', visible: true },
        { title: 'Año', property: 'Year', visible: true },
        { title: 'Mes', property: 'MonthName', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Definir Período de Planilla', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <label>Períodos de planillas cargadas</label>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={pila.setBean} listButtons={listaBotones()} ></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={setPilaDataApplied}>
                    <div className="row">
                        <div className="col-md-6">
                            <AccountantYear label='Vigencia' idSelector={Year} onChange={(e) => { setYear(e) }} />
                        </div>
                        <div className="col-md-6">
                            <MonthEditorbyconst idSelector={Month} onChange={(e) => { setMonth(e) }} />
                        </div>
                    </div>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}